import { cn } from "@/lib/utils";

export const PageHeader = ({ className, children }) => {
  return (
    <div
      className={cn(
        "flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4",
        className,
      )}
    >
      {children}
    </div>
  );
};

export const PageHeaderHeading = ({ title, subtitle, className }) => {
  return (
    <div className={cn("flex-1 min-w-0", className)}>
      <h2 className="text-2xl font-bold tracking-tight text-foreground truncate">
        {title}
      </h2>
      {subtitle && (
        <div className="text-muted-foreground truncate text-sm">
          {subtitle}
        </div>
      )}
    </div>
  );
};

export const PageHeaderActions = ({ className, children }) => {
  return (
    <div className={cn("flex flex-wrap items-center gap-2", className)}>
      {children}
    </div>
  );
};
